module.exports = __webpack_public_path__ + "img/company33.902e9ff4.png";